import React from 'react';
import { company } from '../data/company';
import { SectionHeading } from './SectionHeading';
const facts = [{
  label: 'Artisan indépendant depuis',
  value: String(company.since)
}, {
  label: 'SIREN',
  value: company.siren
}, {
  label: 'Garantie sur les pièces posées',
  value: '2 ans'
}, {
  label: 'Assurance responsabilité civile pro',
  value: 'À jour'
}];
export function About() {
  return <section id="artisan" className="bg-bone py-16 lg:py-24" data-id="element-14" data-mp="33rrlvwohh9sm">
      <div className="mx-auto max-w-content px-5 lg:px-8" data-id="element-15" data-mp="33pf8zxxl1pmf">
        <div className="grid items-start gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-16" data-mp="38p1mm8hbp7vr">
          <div data-id="element-17" data-mp="3dgt3fraofz8p">
            <SectionHeading title={`${company.owner}, serrurier et rien d’autre`} data-id="element-18" data-mp="3di49xyvibl3i" />
            <div className="mt-6 space-y-4 text-base leading-relaxed text-ink-600" data-id="element-19" data-mp="3hiwggkczvbw3">
              <p data-id="element-20" data-mp="3mhzjy0dbta1y">
                J’ai appris le métier sur le terrain, en dépannage, avant d’ouvrir mon atelier à
                Maisons-Laffitte. Aujourd’hui je travaille seul : la personne que vous avez au
                téléphone est celle qui sonne à votre porte.
              </p>
              <p data-id="element-21" data-mp="2gs4e8o9yu3w1">
                Ça change deux choses. Je ne peux pas me permettre une mauvaise réputation dans ma
                propre ville, donc je ne gonfle jamais un devis. Et comme je connais le parc de
                portes du secteur — immeubles des années 70 de la boucle de Seine, portes anciennes
                du centre, bloc-portes récents — j’arrive avec les bons cylindres dans la camionnette.
              </p>
              <p data-id="element-22" data-mp="30h6dy1ial3eq">
                Je pose des cylindres certifiés A2P et je vous explique toujours ce qui est
                réellement utile chez vous. Un blindage complet n’a pas de sens sur toutes les
                portes&nbsp;: souvent, un bon cylindre et une cornière suffisent.
              </p>
            </div>

            <dl className="mt-10 grid gap-px border border-bone-dark bg-bone-dark sm:grid-cols-2" data-id="element-23" data-mp="3o794ueah03br">
              {facts.map(fact => <div key={fact.label} className="bg-bone p-5" data-id="element-24" data-mp="65u30wtzp6nu">
                  <dt className="text-xs font-semibold uppercase tracking-[0.12em] text-ink-500" data-id="element-25" data-mp="66lvhysaio9w">
                    {fact.label}
                  </dt>
                  <dd className="mt-1.5 font-display text-lg font-bold text-ink-900" data-id="element-26" data-mp="3tjfrnirjg492">
                    {fact.value}
                  </dd>
                </div>)}
            </dl>
          </div>

          <img src="https://cdn.magicpatterns.com/patterns/generated-images/ac6a3e85-89ca-4057-9aac-9f7fcbb8ae44.jpg" alt="Porte d’appartement blindée avec plaque de sécurité et serrure trois points, fraîchement posée" className="h-[420px] w-full rounded-sm object-cover lg:h-[620px]" data-id="element-27" data-mp="3jjoz3mmjfzbm" />
        </div>
      </div>
    </section>;
}